window.KicksownSizeData = {
  "version": "2026-10-21-reebok",
  "charts": {
    "lining": {
      "label": "Li-Ning Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US W": "4",
          "EU": "33.5",
          "CM": "20.5"
        },
        {
          "US W": "4.5",
          "EU": "34",
          "CM": "21"
        },
        {
          "US W": "5",
          "EU": "35",
          "CM": "21.5"
        },
        {
          "US M": "4",
          "US W": "5.5",
          "EU": "35.5",
          "CM": "21.5"
        },
        {
          "US M": "4.5",
          "US W": "6",
          "UK": "3.5",
          "EU": "36",
          "CM": "22"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "UK": "4",
          "EU": "37",
          "CM": "22.5"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "UK": "4.5",
          "EU": "37.5",
          "CM": "23"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "UK": "5",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "5.5",
          "EU": "39",
          "CM": "24"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6",
          "EU": "39.5",
          "CM": "24.5"
        },
        {
          "US M": "7.5",
          "US W": "9",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "EU": "40.5"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "UK": "7",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "UK": "7.5",
          "EU": "41.5",
          "CM": "26"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "UK": "8",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "EU": "42.5"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "UK": "8.5",
          "EU": "43",
          "CM": "27"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "UK": "9",
          "EU": "43.5",
          "CM": "27.5"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "UK": "9.5",
          "EU": "44",
          "CM": "28"
        },
        {
          "EU": "44.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "UK": "10",
          "EU": "45",
          "CM": "28.5"
        },
        {
          "US M": "11.5",
          "US W": "13",
          "UK": "10.5",
          "EU": "45.5",
          "CM": "29"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "UK": "11",
          "EU": "46",
          "CM": "29.5"
        },
        {
          "EU": "46.5"
        },
        {
          "US M": "12.5",
          "US W": "14",
          "UK": "11.5",
          "EU": "47",
          "CM": "30"
        },
        {
          "US M": "13",
          "US W": "14.5",
          "UK": "12",
          "EU": "47.5",
          "CM": "30.5"
        },
        {
          "US M": "13.5",
          "US W": "15",
          "UK": "12.5",
          "EU": "48",
          "CM": "31"
        },
        {
          "US M": "14",
          "US W": "15.5",
          "UK": "13",
          "EU": "49",
          "CM": "31.5"
        },
        {
          "US M": "14.5",
          "US W": "16",
          "UK": "13.5",
          "EU": "49.5",
          "CM": "32"
        },
        {
          "US M": "15",
          "US W": "16.5",
          "UK": "14",
          "EU": "50",
          "CM": "32.5"
        },
        {
          "US M": "15.5",
          "US W": "17",
          "UK": "14.5",
          "EU": "51",
          "CM": "33"
        },
        {
          "US M": "16",
          "US W": "17.5",
          "UK": "15",
          "EU": "51.5",
          "CM": "33.5"
        },
        {
          "US M": "16.5",
          "US W": "18",
          "UK": "15.5",
          "EU": "52",
          "CM": "34"
        }
      ]
    },
    "lining-kids": {
      "label": "Li-Ning Kids Size Guide",
      "systems": [
        "US Kids",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US Kids": "11C",
          "UK": "10.5",
          "EU": "28",
          "CM": "17.5"
        },
        {
          "US Kids": "11TC",
          "UK": "11",
          "EU": "29",
          "CM": "18"
        },
        {
          "US Kids": "12TC",
          "UK": "12",
          "EU": "30",
          "CM": "18.5"
        },
        {
          "US Kids": "0.5",
          "UK": "13",
          "EU": "31",
          "CM": "19.5"
        },
        {
          "US Kids": "1.5",
          "UK": "1",
          "EU": "32",
          "CM": "20"
        },
        {
          "US Kids": "2",
          "UK": "1.5",
          "EU": "33",
          "CM": "20.5"
        },
        {
          "US Kids": "3",
          "UK": "2.5",
          "EU": "34",
          "CM": "21.5"
        },
        {
          "US Kids": "3.5",
          "UK": "3",
          "EU": "35",
          "CM": "22"
        },
        {
          "US Kids": "4.5",
          "UK": "4",
          "EU": "36",
          "CM": "23"
        },
        {
          "US Kids": "5",
          "UK": "4.5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US Kids": "6",
          "UK": "5.5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US Kids": "6.5",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US Kids": "7.5",
          "UK": "7",
          "EU": "40",
          "CM": "25"
        },
        {
          "US Kids": "8",
          "UK": "7.5",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US Kids": "9",
          "UK": "8.5",
          "EU": "42",
          "CM": "26"
        }
      ]
    },
    "anta": {
      "label": "ANTA Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US W": "5",
          "EU": "35.5",
          "CM": "22"
        },
        {
          "US W": "5.5",
          "EU": "36",
          "CM": "22.5"
        },
        {
          "US W": "6",
          "EU": "36.5",
          "CM": "23"
        },
        {
          "US W": "6.5",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US W": "7",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US W": "7.5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "42.5",
          "CM": "26.5"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "43",
          "CM": "27"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "44",
          "CM": "27"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "27.5"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "45",
          "CM": "28"
        },
        {
          "US M": "11.5",
          "UK": "10.5",
          "EU": "45.5",
          "CM": "28.5"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46",
          "CM": "29"
        },
        {
          "US M": "12.5",
          "UK": "11.5",
          "EU": "47",
          "CM": "29.5"
        },
        {
          "US M": "13",
          "UK": "12",
          "EU": "47.5",
          "CM": "30"
        },
        {
          "US M": "13.5",
          "UK": "12.5",
          "EU": "48",
          "CM": "30.5"
        },
        {
          "US M": "14",
          "UK": "13",
          "EU": "48.5",
          "CM": "30.5"
        },
        {
          "US M": "14.5",
          "UK": "13.5",
          "EU": "49",
          "CM": "31"
        },
        {
          "US M": "15",
          "UK": "14",
          "EU": "49.5",
          "CM": "31.5"
        },
        {
          "US M": "16",
          "UK": "15",
          "EU": "50.5",
          "CM": "32.5"
        },
        {
          "US M": "17",
          "UK": "16",
          "EU": "51.5",
          "CM": "33.5"
        }
      ]
    },
    "anta-kids": {
      "label": "ANTA Kids Size Guide",
      "systems": [
        "US Kids",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US Kids": "1.5Y",
          "UK": "1",
          "EU": "33",
          "CM": "20.5"
        },
        {
          "US Kids": "2.5Y",
          "UK": "2",
          "EU": "34",
          "CM": "21.5"
        },
        {
          "US Kids": "3Y",
          "UK": "2.5",
          "EU": "35",
          "CM": "22"
        },
        {
          "US Kids": "4Y",
          "UK": "3.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US Kids": "5Y",
          "UK": "4.5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US Kids": "5.5Y",
          "UK": "5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US Kids": "6.5Y",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US Kids": "7Y",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US Kids": "8Y",
          "UK": "7.5",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US Kids": "8.5Y",
          "EU": "42",
          "CM": "26"
        }
      ]
    },
    "peak": {
      "label": "PEAK Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US W": "3",
          "UK": "W1",
          "EU": "33",
          "CM": "21.5"
        },
        {
          "US W": "4",
          "UK": "W1.5",
          "EU": "34",
          "CM": "22"
        },
        {
          "US W": "4.5",
          "UK": "W2",
          "EU": "35",
          "CM": "22.5"
        },
        {
          "US W": "5.5",
          "UK": "W3",
          "EU": "36",
          "CM": "23"
        },
        {
          "US W": "6.5",
          "UK": "W3.5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "US W": "7",
          "UK": "W4.5/M5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "W5.5/M6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "W6/M6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "UK": "7",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "9",
          "US W": "10",
          "UK": "7.5",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "43",
          "CM": "26.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "44",
          "CM": "27"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "45",
          "CM": "27.5"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46",
          "CM": "28"
        },
        {
          "US M": "13",
          "UK": "12",
          "EU": "47",
          "CM": "28.5"
        },
        {
          "US M": "14",
          "UK": "13",
          "EU": "48",
          "CM": "29"
        },
        {
          "US M": "15",
          "UK": "14",
          "EU": "49",
          "CM": "29.5"
        },
        {
          "US M": "16",
          "UK": "15",
          "EU": "50",
          "CM": "30"
        }
      ]
    },
    "peak-kids": {
      "label": "PEAK Kids Size Guide",
      "systems": [
        "US Kids",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US Kids": "8C",
          "EU": "25",
          "CM": "15.5"
        },
        {
          "US Kids": "9C",
          "EU": "26",
          "CM": "16"
        },
        {
          "US Kids": "10C",
          "EU": "27",
          "CM": "16.5"
        },
        {
          "US Kids": "11C",
          "EU": "28",
          "CM": "17.5"
        },
        {
          "US Kids": "12C",
          "EU": "29",
          "CM": "18"
        },
        {
          "US Kids": "13C",
          "EU": "31",
          "CM": "19"
        },
        {
          "US Kids": "1Y",
          "EU": "32",
          "CM": "19.5"
        },
        {
          "US Kids": "1.5Y",
          "EU": "33",
          "CM": "20.5"
        },
        {
          "US Kids": "2.5Y",
          "EU": "34",
          "CM": "21.5"
        },
        {
          "US Kids": "3Y",
          "EU": "35",
          "CM": "22"
        },
        {
          "US Kids": "4Y",
          "EU": "36",
          "CM": "22"
        },
        {
          "US Kids": "5Y",
          "EU": "37",
          "CM": "23"
        },
        {
          "US Kids": "5.5Y",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US Kids": "6.5Y",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US Kids": "7Y",
          "EU": "40",
          "CM": "25"
        }
      ]
    },
    "xtep": {
      "label": "Xtep Jeremy Lin Basketball Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "6.5",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "7",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7.5",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "8",
          "EU": "43",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8.5",
          "EU": "44",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "9",
          "EU": "45",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9.5",
          "EU": "46",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "10",
          "EU": "47",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "UK": "10.5",
          "EU": "48",
          "CM": "29"
        }
      ]
    },
    "bmai": {
      "label": "BMAI Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3.5",
          "EU": "35",
          "CM": "21.5"
        },
        {
          "US M": "4",
          "EU": "36",
          "CM": "22"
        },
        {
          "US M": "4.5",
          "EU": "36.5",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "EU": "37",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "7",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7.5",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "8",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8.5",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "9",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9.5",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "10",
          "EU": "45",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "UK": "10.5",
          "EU": "46",
          "CM": "29"
        }
      ]
    },
    "qiaodan": {
      "label": "QIAODAN Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3",
          "US W": "4.5",
          "UK": "2",
          "EU": "35",
          "CM": "21.5"
        },
        {
          "US M": "3.5",
          "US W": "5",
          "UK": "2.5",
          "EU": "35.5",
          "CM": "22"
        },
        {
          "US M": "4",
          "US W": "5.5",
          "UK": "3",
          "EU": "36",
          "CM": "22.5"
        },
        {
          "US M": "4.5",
          "US W": "6",
          "UK": "3.5",
          "EU": "37",
          "CM": "23"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "UK": "4",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "UK": "4.5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "UK": "5",
          "EU": "38.5",
          "CM": "24.5"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "5.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46",
          "CM": "29.5"
        },
        {
          "US M": "12.5",
          "UK": "11.5",
          "EU": "47",
          "CM": "30"
        },
        {
          "US M": "13.5",
          "UK": "12.5",
          "EU": "48",
          "CM": "30.5"
        }
      ]
    },
    "under-armour": {
      "label": "Under Armour Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3.5",
          "US W": "5",
          "UK": "3",
          "EU": "35.5",
          "CM": "22.5"
        },
        {
          "US M": "4",
          "US W": "5.5",
          "UK": "3.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "4.5",
          "US W": "6",
          "UK": "4",
          "EU": "36.5",
          "CM": "23.5"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "UK": "4.5",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "UK": "4.5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "UK": "5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "5.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "US W": "9",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "UK": "7",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "UK": "7.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "UK": "8",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "UK": "8.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "UK": "9",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "UK": "10",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "US W": "13",
          "UK": "10.5",
          "EU": "45.5",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "UK": "11",
          "EU": "46",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "US W": "14",
          "UK": "11.5",
          "EU": "47",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "US W": "14.5",
          "UK": "12",
          "EU": "47.5",
          "CM": "31"
        },
        {
          "US M": "13.5",
          "US W": "15",
          "UK": "12.5",
          "EU": "48",
          "CM": "31.5"
        },
        {
          "US M": "14",
          "US W": "15.5",
          "UK": "13",
          "EU": "48.5",
          "CM": "32"
        },
        {
          "US M": "14.5",
          "US W": "16",
          "UK": "13.5",
          "EU": "49",
          "CM": "32.5"
        },
        {
          "US M": "15",
          "US W": "16.5",
          "UK": "14",
          "EU": "49.5",
          "CM": "33"
        },
        {
          "US M": "15.5",
          "US W": "17",
          "UK": "14.5",
          "EU": "50",
          "CM": "33.5"
        },
        {
          "US M": "16",
          "US W": "17.5",
          "UK": "15",
          "EU": "50.5",
          "CM": "34"
        }
      ]
    },
    "erke": {
      "label": "ERKE Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US W": "4.5",
          "UK": "3",
          "EU": "33",
          "CM": "21.5"
        },
        {
          "US W": "5",
          "UK": "3.5",
          "EU": "34",
          "CM": "22"
        },
        {
          "US W": "5.5",
          "UK": "4",
          "EU": "35",
          "CM": "22.5"
        },
        {
          "US W": "6",
          "UK": "4.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US W": "6.5",
          "UK": "5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US W": "7",
          "UK": "5.5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "7.5",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "US W": "8.5",
          "UK": "7",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7.5",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "8",
          "EU": "43",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8.5",
          "EU": "44",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "9",
          "EU": "45",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9.5",
          "EU": "46",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "10",
          "EU": "47",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "UK": "10.5",
          "EU": "48",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "UK": "11",
          "EU": "49",
          "CM": "29.5"
        }
      ]
    },
    "tansher": {
      "label": "TANSHER Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "5",
          "UK": "4",
          "EU": "35",
          "CM": "22.5"
        },
        {
          "US M": "5.5",
          "UK": "4.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "6",
          "UK": "5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US M": "6.5",
          "UK": "5.5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "43",
          "CM": "26.5"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "44",
          "CM": "27"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "45",
          "CM": "27.5"
        }
      ]
    },
    "rigorer-1": {
      "label": "Rigorer Size Guide 1",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US W": "5.5",
          "UK": "3.5",
          "EU": "35",
          "CM": "22"
        },
        {
          "US W": "6",
          "UK": "4",
          "EU": "36",
          "CM": "22.5"
        },
        {
          "US W": "6.5",
          "UK": "4.5",
          "EU": "37",
          "CM": "23"
        },
        {
          "US W": "7.5",
          "UK": "5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "5.5",
          "EU": "39",
          "CM": "25"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "40",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "43",
          "CM": "27"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "44",
          "CM": "27.5"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "45",
          "CM": "28.5"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46",
          "CM": "29"
        },
        {
          "US M": "13",
          "UK": "12",
          "EU": "47",
          "CM": "30"
        },
        {
          "US M": "14",
          "UK": "13",
          "EU": "48",
          "CM": "30.5"
        },
        {
          "US M": "14.5",
          "UK": "13.5",
          "EU": "49",
          "CM": "31"
        },
        {
          "US M": "15",
          "UK": "14",
          "EU": "50",
          "CM": "32"
        },
        {
          "US M": "16",
          "UK": "15",
          "EU": "51",
          "CM": "32.5"
        },
        {
          "US M": "17",
          "UK": "16",
          "EU": "52",
          "CM": "33"
        }
      ]
    },
    "rigorer-2": {
      "label": "Rigorer Size Guide 2",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US W": "5.5",
          "UK": "3.5",
          "EU": "35",
          "CM": "22"
        },
        {
          "US W": "6",
          "UK": "4",
          "EU": "36",
          "CM": "22.5"
        },
        {
          "US W": "6.5",
          "UK": "4.5",
          "EU": "37",
          "CM": "23"
        },
        {
          "US W": "7.5",
          "UK": "5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US W": "8",
          "UK": "5.5",
          "EU": "39",
          "CM": "25"
        },
        {
          "US M": "6.5",
          "UK": "5.5",
          "EU": "39",
          "CM": "24"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "40",
          "CM": "24.5"
        },
        {
          "US M": "7.5",
          "UK": "7",
          "EU": "40.5",
          "CM": "25"
        },
        {
          "US M": "8",
          "UK": "8",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8.5",
          "UK": "8.5",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "9",
          "UK": "9",
          "EU": "42.5",
          "CM": "26.5"
        },
        {
          "US M": "9.5",
          "UK": "9.5",
          "EU": "43",
          "CM": "27"
        },
        {
          "US M": "10",
          "UK": "10",
          "EU": "44",
          "CM": "27.5"
        },
        {
          "US M": "10.5",
          "UK": "11",
          "EU": "44.5",
          "CM": "28"
        },
        {
          "US M": "11",
          "UK": "12",
          "EU": "45",
          "CM": "28.5"
        },
        {
          "US M": "11.5",
          "UK": "13",
          "EU": "45.5",
          "CM": "29"
        },
        {
          "US M": "12",
          "UK": "13.5",
          "EU": "46",
          "CM": "29.5"
        },
        {
          "US M": "13",
          "UK": "14",
          "EU": "47.5",
          "CM": "30.5"
        },
        {
          "US M": "14",
          "UK": "15",
          "EU": "48.5",
          "CM": "31.5"
        },
        {
          "US M": "15",
          "UK": "16",
          "EU": "49.5",
          "CM": "32"
        }
      ]
    },
    "rigorer-kids": {
      "label": "Rigorer Kids Size Guide",
      "systems": [
        "US Kids",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US Kids": "12.5C",
          "EU": "30",
          "CM": "18.5"
        },
        {
          "US Kids": "0.5",
          "EU": "31",
          "CM": "19.5"
        },
        {
          "US Kids": "1.5",
          "EU": "32",
          "CM": "20"
        },
        {
          "US Kids": "2",
          "EU": "33",
          "CM": "20.5"
        },
        {
          "US Kids": "3",
          "EU": "34",
          "CM": "21.5"
        },
        {
          "US Kids": "3.5",
          "EU": "35",
          "CM": "22"
        },
        {
          "US Kids": "4.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US Kids": "5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US Kids": "6",
          "EU": "38",
          "CM": "24"
        },
        {
          "US Kids": "6.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US Kids": "7.5",
          "EU": "40",
          "CM": "25"
        }
      ]
    },
    "rigorer-slides": {
      "label": "Rigorer Slides Size Guide",
      "systems": [
        "US M",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "8",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "9",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "9.5",
          "EU": "43",
          "CM": "26.5"
        },
        {
          "US M": "10",
          "EU": "44",
          "CM": "27"
        },
        {
          "US M": "11",
          "EU": "45",
          "CM": "27.5"
        },
        {
          "US M": "12",
          "EU": "46",
          "CM": "28"
        },
        {
          "US M": "13",
          "EU": "47",
          "CM": "28.5"
        },
        {
          "US M": "14",
          "EU": "48",
          "CM": "29"
        },
        {
          "US M": "15",
          "EU": "49",
          "CM": "29.5"
        },
        {
          "US M": "16",
          "EU": "50",
          "CM": "30"
        },
        {
          "US M": "17",
          "EU": "51",
          "CM": "30.5"
        }
      ]
    },
    "361-1": {
      "label": "361° Size Guide 1",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US W": "5",
          "UK": "2.5",
          "EU": "35",
          "CM": "22.5"
        },
        {
          "US W": "6",
          "UK": "3.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US W": "7",
          "UK": "4.5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US W": "7.5",
          "UK": "5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "5.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "43",
          "CM": "26.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "44",
          "CM": "27"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "45",
          "CM": "27.5"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "46",
          "CM": "28"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "47",
          "CM": "28.5"
        },
        {
          "US M": "12.5",
          "UK": "11.5",
          "EU": "48",
          "CM": "29"
        }
      ]
    },
    "361-2": {
      "label": "361° Size Guide 2",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3",
          "US W": "4.5",
          "UK": "2.5",
          "EU": "35",
          "CM": "22"
        },
        {
          "US M": "3.5",
          "US W": "5",
          "UK": "3",
          "EU": "35.5",
          "CM": "22.5"
        },
        {
          "US M": "4",
          "US W": "5.5",
          "UK": "3.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "4.5",
          "US W": "6",
          "UK": "4",
          "EU": "36.5",
          "CM": "23.5"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "UK": "4.5",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "UK": "5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "UK": "5.5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "US W": "9",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "UK": "7",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "UK": "7.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "UK": "8",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "UK": "8.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "UK": "9",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "UK": "10",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "US W": "13",
          "UK": "10.5",
          "EU": "45.5",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "UK": "11",
          "EU": "46",
          "CM": "29.5"
        },
        {
          "US M": "12.5",
          "US W": "14",
          "UK": "11.5",
          "EU": "47",
          "CM": "30"
        },
        {
          "US M": "13",
          "US W": "14.5",
          "UK": "12",
          "EU": "47.5",
          "CM": "30.5"
        },
        {
          "US M": "13.5",
          "US W": "15",
          "UK": "12.5",
          "EU": "48",
          "CM": "31"
        },
        {
          "US M": "14",
          "US W": "15.5",
          "UK": "13",
          "EU": "48.5",
          "CM": "31.5"
        },
        {
          "US M": "14.5",
          "US W": "16",
          "UK": "13.5",
          "EU": "49",
          "CM": "32"
        },
        {
          "US M": "15",
          "US W": "16.5",
          "UK": "14",
          "EU": "49.5",
          "CM": "32.5"
        },
        {
          "US M": "15.5",
          "US W": "17",
          "UK": "14.5",
          "EU": "50",
          "CM": "33"
        }
      ]
    },
    "361-slides": {
      "label": "361° Slides Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "6.5",
          "UK": "5.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "43",
          "CM": "26.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "44",
          "CM": "27"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "45",
          "CM": "27.5"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "46",
          "CM": "28"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "47",
          "CM": "28.5"
        }
      ]
    },
    "eqlz": {
      "label": "EQLZ Size Guide",
      "systems": [
        "US M",
        "US W",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "4.5",
          "US W": "6",
          "EU": "36.5",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "EU": "37.5",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "US W": "9",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "US W": "13",
          "EU": "45.5",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "EU": "46",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "US W": "14",
          "EU": "47",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "US W": "14.5",
          "EU": "47.5",
          "CM": "31"
        },
        {
          "US M": "14",
          "EU": "48.5",
          "CM": "32"
        },
        {
          "US M": "15",
          "EU": "49.5",
          "CM": "33"
        }
      ]
    },
    "eqlz-slides": {
      "label": "EQLZ Slides Size Guide",
      "systems": [
        "US M",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3-3.5",
          "EU": "34-35",
          "CM": "20.5-21.5"
        },
        {
          "US M": "4-4.5",
          "EU": "36-37",
          "CM": "22-23"
        },
        {
          "US M": "5.5-6.5",
          "EU": "38-39",
          "CM": "23.5-24.5"
        },
        {
          "US M": "7-8",
          "EU": "40-41",
          "CM": "25-26"
        },
        {
          "US M": "8.5-9",
          "EU": "42-42.5",
          "CM": "26.5-27"
        },
        {
          "US M": "9.5-10",
          "EU": "43-44",
          "CM": "27.5-28"
        },
        {
          "US M": "10.5-11",
          "EU": "44.5-45",
          "CM": "28.5-29"
        },
        {
          "US M": "11.5-12",
          "EU": "45.5-46",
          "CM": "29.5-30"
        },
        {
          "US M": "12.5-13",
          "EU": "47-47.5",
          "CM": "30.5-31"
        }
      ]
    },
    "spo": {
      "label": "Serious Player Only Size Guide",
      "systems": [
        "US M",
        "US W",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US W": "5.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US W": "6.5",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US W": "7",
          "EU": "38",
          "CM": "24"
        },
        {
          "US W": "8",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "8",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "EU": "45.5",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "EU": "46",
          "CM": "30"
        },
        {
          "US M": "13",
          "EU": "47.5",
          "CM": "31"
        },
        {
          "US M": "14",
          "EU": "48.5",
          "CM": "32"
        },
        {
          "US M": "15",
          "EU": "49.5",
          "CM": "33"
        },
        {
          "US M": "16",
          "EU": "50.5",
          "CM": "34"
        }
      ]
    },
    "dowin": {
      "label": "Dowin Size Guide",
      "systems": [
        "US M",
        "US W",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "4.5",
          "US W": "6",
          "EU": "35",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "EU": "41.5",
          "CM": "26"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "EU": "43",
          "CM": "27"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "EU": "44",
          "CM": "27.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "EU": "45",
          "CM": "28"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "EU": "46",
          "CM": "28.5"
        }
      ]
    },
    "reebok": {
      "label": "Reebok Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {"US M":"3.5","US W":"5","UK":"2.5","EU":"34","CM":"22.5"},
        {"US M":"4","US W":"5.5","UK":"3","EU":"34.5","CM":"23"},
        {"US M":"4.5","US W":"6","UK":"3.5","EU":"35","CM":"23.3"},
        {"US M":"5","US W":"6.5","UK":"4","EU":"36","CM":"23.5"},
        {"US M":"5.5","US W":"7","UK":"4.5","EU":"36.5","CM":"23.6"},
        {"US M":"6","US W":"7.5","UK":"5","EU":"37.5","CM":"24"},
        {"US M":"6.5","US W":"8","UK":"5.5","EU":"38.5","CM":"24.5"},
        {"US M":"7","US W":"8.5","UK":"6","EU":"39","CM":"25"},
        {"US M":"7.5","US W":"9","UK":"6.5","EU":"40","CM":"25.5"},
        {"US M":"8","US W":"9.5","UK":"7","EU":"40.5","CM":"26"},
        {"US M":"8.5","US W":"10","UK":"7.5","EU":"41","CM":"26.5"},
        {"US M":"9","US W":"10.5","UK":"8","EU":"42","CM":"27"},
        {"US M":"9.5","US W":"11","UK":"8.5","EU":"42.5","CM":"27.5"},
        {"US M":"10","US W":"11.5","UK":"9","EU":"43","CM":"28"},
        {"US M":"10.5","US W":"12","UK":"9.5","EU":"44","CM":"28.5"},
        {"US M":"11","US W":"12.5","UK":"10","EU":"44.5","CM":"29"},
        {"US M":"11.5","US W":"13","UK":"10.5","EU":"45","CM":"29.5"},
        {"US M":"12","US W":"13.5","UK":"11","EU":"45.5","CM":"30"},
        {"US M":"12.5","US W":"14","UK":"11.5","EU":"46","CM":"30.5"},
        {"US M":"13","US W":"14.5","UK":"12","EU":"47","CM":"31"},
        {"US M":"13.5","US W":"15","UK":"12.5","EU":"48","CM":"31.5"},
        {"US M":"14","US W":"15.5","UK":"13","EU":"48.5","CM":"32"}
      ]
    },
    "nike": {
      "label": "Nike Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3.5",
          "US W": "5",
          "UK": "3",
          "EU": "35.5",
          "CM": "22.5"
        },
        {
          "US M": "4",
          "US W": "5.5",
          "UK": "3.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "4.5",
          "US W": "6",
          "UK": "4",
          "EU": "36.5",
          "CM": "23.5"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "UK": "4.5",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "UK": "5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "UK": "5.5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "US W": "9",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "UK": "7",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "UK": "7.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "UK": "8",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "UK": "8.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "UK": "9",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "UK": "10",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "US W": "13",
          "UK": "10.5",
          "EU": "45.5",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "UK": "11",
          "EU": "46",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "US W": "14",
          "UK": "11.5",
          "EU": "47",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "US W": "14.5",
          "UK": "12",
          "EU": "47.5",
          "CM": "31"
        },
        {
          "US M": "13.5",
          "US W": "15",
          "UK": "12.5",
          "EU": "48",
          "CM": "31.5"
        },
        {
          "US M": "14",
          "US W": "15.5",
          "UK": "13",
          "EU": "48.5",
          "CM": "32"
        },
        {
          "US M": "15",
          "UK": "14",
          "EU": "49.5",
          "CM": "33"
        },
        {
          "US M": "16",
          "UK": "15",
          "EU": "50.5",
          "CM": "34"
        },
        {
          "US M": "17",
          "UK": "16",
          "EU": "51.5",
          "CM": "35"
        }
      ]
    },
    "xtep-running": {
      "label": "Xtep Running Shoes Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "4.5",
          "UK": "3.5",
          "EU": "37",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "UK": "4",
          "EU": "37.5",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "UK": "4.5",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "UK": "5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "UK": "5.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "UK": "10.5",
          "EU": "46",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46.5",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "UK": "11.5",
          "EU": "47",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "UK": "12",
          "EU": "48",
          "CM": "31"
        }
      ]
    },
    "volanti": {
      "label": "Volanti Size Guide",
      "systems": [
        "US M",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "4",
          "EU": "36",
          "CM": "22.5"
        },
        {
          "US M": "4.5",
          "EU": "36.5",
          "CM": "23"
        },
        {
          "US M": "5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US M": "5.5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "EU": "45.5",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "EU": "46",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "EU": "47",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "EU": "48",
          "CM": "31.5"
        },
        {
          "US M": "13.5",
          "EU": "49",
          "CM": "32"
        },
        {
          "US M": "14.5",
          "EU": "50",
          "CM": "32.5"
        }
      ]
    },
    "adidas-yeezy": {
      "label": "Adidas Yeezy Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3.5",
          "UK": "3",
          "EU": "35 2/3",
          "CM": "21.5"
        },
        {
          "US M": "4",
          "UK": "3.5",
          "EU": "36",
          "CM": "22"
        },
        {
          "US M": "4.5",
          "UK": "4",
          "EU": "36 2/3",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "UK": "4.5",
          "EU": "37 1/3",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "UK": "5",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "UK": "5.5",
          "EU": "38 2/3",
          "CM": "23.5"
        },
        {
          "US M": "6.5",
          "UK": "6",
          "EU": "39 1/3",
          "CM": "24"
        },
        {
          "US M": "7",
          "UK": "6.5",
          "EU": "40",
          "CM": "24.5"
        },
        {
          "US M": "7.5",
          "UK": "7",
          "EU": "40 2/3",
          "CM": "25"
        },
        {
          "US M": "8",
          "UK": "7.5",
          "EU": "41 1/3",
          "CM": "25.5"
        },
        {
          "US M": "8.5",
          "UK": "8",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "9",
          "UK": "8.5",
          "EU": "42 2/3",
          "CM": "26.5"
        },
        {
          "US M": "9.5",
          "UK": "9",
          "EU": "43 1/3",
          "CM": "26.5"
        },
        {
          "US M": "10",
          "UK": "9.5",
          "EU": "44",
          "CM": "27"
        },
        {
          "US M": "10.5",
          "UK": "10",
          "EU": "44 2/3",
          "CM": "27.5"
        },
        {
          "US M": "11",
          "UK": "10.5",
          "EU": "45 1/3",
          "CM": "28"
        },
        {
          "US M": "11.5",
          "UK": "11",
          "EU": "46",
          "CM": "28.5"
        },
        {
          "US M": "12",
          "UK": "11.5",
          "EU": "46 2/3",
          "CM": "29"
        },
        {
          "US M": "12.5",
          "UK": "12",
          "EU": "47 1/3",
          "CM": "29"
        },
        {
          "US M": "13",
          "UK": "12.5",
          "EU": "48",
          "CM": "29.5"
        },
        {
          "US M": "13.5",
          "UK": "13",
          "EU": "48 2/3",
          "CM": "30"
        },
        {
          "US M": "14",
          "UK": "13.5",
          "EU": "49 1/3",
          "CM": "30.5"
        },
        {
          "US M": "14.5",
          "UK": "14",
          "EU": "50",
          "CM": "31"
        },
        {
          "US M": "15",
          "UK": "14.5",
          "EU": "50 2/3",
          "CM": "31.5"
        },
        {
          "US M": "16",
          "UK": "15",
          "EU": "51 1/3",
          "CM": "32"
        },
        {
          "US M": "17",
          "UK": "16",
          "EU": "52 2/3",
          "CM": "32.5"
        }
      ]
    },
    "adidas": {
      "label": "Adidas Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3",
          "US W": "4",
          "UK": "2.5",
          "EU": "35",
          "CM": "21"
        },
        {
          "US M": "3.5",
          "US W": "4.5",
          "UK": "3",
          "EU": "35 2/3",
          "CM": "21.5"
        },
        {
          "US M": "4",
          "US W": "5",
          "UK": "3.5",
          "EU": "36",
          "CM": "22"
        },
        {
          "US M": "4.5",
          "US W": "5.5",
          "UK": "4",
          "EU": "36 2/3",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "US W": "6",
          "UK": "4.5",
          "EU": "37 1/3",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "US W": "6.5",
          "UK": "5",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "US W": "7",
          "UK": "5.5",
          "EU": "38 2/3",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "7.5",
          "UK": "6",
          "EU": "39 1/3",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "US W": "8.5",
          "UK": "7",
          "EU": "40 2/3",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "US W": "9",
          "UK": "7.5",
          "EU": "41 1/3",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "US W": "9.5",
          "UK": "8",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "US W": "10",
          "UK": "8.5",
          "EU": "42 2/3",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "US W": "10.5",
          "UK": "9",
          "EU": "43 1/3",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "US W": "11",
          "UK": "9.5",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "US W": "11.5",
          "UK": "10",
          "EU": "44 2/3",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "US W": "12",
          "UK": "10.5",
          "EU": "45 1/3",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "US W": "12.5",
          "UK": "11",
          "EU": "46",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "US W": "13",
          "UK": "11.5",
          "EU": "46 2/3",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "US W": "13.5",
          "UK": "12",
          "EU": "47 1/3",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "US W": "14",
          "UK": "12.5",
          "EU": "48",
          "CM": "31"
        },
        {
          "US M": "13.5",
          "US W": "14.5",
          "UK": "13",
          "EU": "48 2/3",
          "CM": "31.5"
        },
        {
          "US M": "14",
          "US W": "15",
          "UK": "13.5",
          "EU": "49 1/3",
          "CM": "32"
        },
        {
          "US M": "14.5",
          "US W": "15.5",
          "UK": "14",
          "EU": "50",
          "CM": "32.5"
        },
        {
          "US M": "15",
          "UK": "14.5",
          "EU": "50 2/3"
        },
        {
          "US M": "16",
          "UK": "15",
          "EU": "51 1/3"
        },
        {
          "US M": "17",
          "UK": "16",
          "EU": "52 2/3"
        },
        {
          "US M": "18",
          "UK": "17",
          "EU": "53 1/3"
        },
        {
          "US M": "19",
          "UK": "18",
          "EU": "54 2/3"
        },
        {
          "US M": "20",
          "UK": "19",
          "EU": "55 2/3"
        }
      ]
    },
    "asics": {
      "label": "ASICS Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "4",
          "UK": "3",
          "EU": "36",
          "CM": "22.5"
        },
        {
          "US M": "4.5",
          "UK": "3.5",
          "EU": "37",
          "CM": "23"
        },
        {
          "US M": "2",
          "UK": "4",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US M": "5.5",
          "UK": "4.5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6",
          "UK": "5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "6.5",
          "UK": "5.5",
          "EU": "39.5",
          "CM": "25"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "40"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41.5",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "43.5",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "44.5"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "45",
          "CM": "28.5"
        },
        {
          "US M": "11.5",
          "UK": "10.5",
          "EU": "46",
          "CM": "29"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46.5",
          "CM": "29.5"
        },
        {
          "US M": "12.5",
          "UK": "11.5",
          "EU": "47",
          "CM": "30"
        },
        {
          "US M": "13",
          "UK": "12",
          "EU": "48",
          "CM": "30.5"
        },
        {
          "US M": "14",
          "UK": "13",
          "EU": "49",
          "CM": "31"
        }
      ]
    },
    "converse": {
      "label": "Converse Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3",
          "US W": "4.5",
          "UK": "2.5",
          "EU": "35",
          "CM": "21"
        },
        {
          "US M": "3.5",
          "US W": "5",
          "UK": "3",
          "EU": "35.5",
          "CM": "21.5"
        },
        {
          "US M": "4",
          "US W": "5.5",
          "UK": "3.5",
          "EU": "36",
          "CM": "22"
        },
        {
          "US M": "4.5",
          "US W": "6",
          "UK": "4",
          "EU": "37",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "UK": "4.5",
          "EU": "37.5",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "UK": "5",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "UK": "5.5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "5.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "US W": "9",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "UK": "7",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "UK": "7.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "UK": "8",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "UK": "8.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "UK": "9",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "UK": "10",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "US W": "13",
          "UK": "10.5",
          "EU": "46",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "UK": "11",
          "EU": "46.5",
          "CM": "30"
        },
        {
          "US M": "13",
          "US W": "14",
          "UK": "11.5",
          "EU": "47",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "US W": "14.5",
          "UK": "12",
          "EU": "47.5",
          "CM": "31"
        },
        {
          "US M": "13.5",
          "US W": "15",
          "UK": "12.5",
          "EU": "48",
          "CM": "31.5"
        },
        {
          "US M": "14",
          "US W": "15.5",
          "UK": "13",
          "EU": "49",
          "CM": "32"
        },
        {
          "US M": "15",
          "US W": "16.5",
          "UK": "13.5",
          "EU": "49.5",
          "CM": "32.5"
        },
        {
          "US M": "15",
          "US W": "16.5",
          "UK": "14",
          "EU": "50",
          "CM": "33"
        },
        {
          "US M": "16",
          "US W": "17.5",
          "UK": "15",
          "EU": "51.5",
          "CM": "34"
        },
        {
          "US M": "17",
          "US W": "18.5",
          "UK": "16",
          "EU": "53",
          "CM": "35"
        },
        {
          "US M": "18",
          "US W": "19.5",
          "UK": "17",
          "EU": "54.5",
          "CM": "36"
        }
      ]
    },
    "mizuno": {
      "label": "Mizuno Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "4",
          "UK": "3",
          "EU": "35",
          "CM": "22"
        },
        {
          "US M": "4.5",
          "UK": "3.5",
          "EU": "36",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "UK": "4",
          "EU": "36.5",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "UK": "4.5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "UK": "5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "UK": "5.5",
          "EU": "38.5",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "39",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "40",
          "CM": "24.4"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "40.5",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "41",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "42",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "42.5",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "43",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "44",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "44.5",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "UK": "10.5",
          "EU": "45",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "UK": "11.5",
          "EU": "46.5",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "UK": "12",
          "EU": "47",
          "CM": "31"
        },
        {
          "US M": "14",
          "UK": "13",
          "EU": "48.5",
          "CM": "32"
        },
        {
          "US M": "15",
          "UK": "14",
          "EU": "50",
          "CM": "33"
        },
        {
          "US M": "16",
          "UK": "15",
          "EU": "51",
          "CM": "34"
        }
      ]
    },
    "new-balance": {
      "label": "New Balance Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3",
          "UK": "2.5",
          "EU": "35",
          "CM": "21"
        },
        {
          "US M": "3.5",
          "UK": "3",
          "EU": "35.5",
          "CM": "21.5"
        },
        {
          "US M": "4",
          "UK": "3.5",
          "EU": "36",
          "CM": "22"
        },
        {
          "US M": "4.5",
          "UK": "4",
          "EU": "37",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "UK": "4.5",
          "EU": "37.5",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "UK": "5",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "UK": "5.5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "UK": "6",
          "EU": "39.5",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "7",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7.5",
          "EU": "41.5",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "8",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8.5",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "9",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9.5",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "10",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "UK": "10.5",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "UK": "11",
          "EU": "45.5",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "UK": "11.5",
          "EU": "46.5",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "UK": "12",
          "EU": "47",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "UK": "12.5",
          "EU": "47.5",
          "CM": "31"
        },
        {
          "US M": "14",
          "UK": "13.5",
          "EU": "49",
          "CM": "32"
        },
        {
          "US M": "15",
          "UK": "14.5",
          "EU": "50",
          "CM": "33"
        },
        {
          "US M": "16",
          "UK": "15.5",
          "EU": "51",
          "CM": "34"
        }
      ]
    },
    "puma": {
      "label": "PUMA Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3.5",
          "UK": "2.5",
          "EU": "35",
          "CM": "21.5"
        },
        {
          "US M": "4",
          "UK": "3",
          "EU": "35.5",
          "CM": "22"
        },
        {
          "US M": "4.5",
          "UK": "3.5",
          "EU": "36",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "UK": "4",
          "EU": "37",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "UK": "4.5",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "UK": "5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "UK": "5.5",
          "EU": "38.5",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "39",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "40",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "40.5",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "41",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "42",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "42.5",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "43",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "44",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "44.5",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "UK": "10.5",
          "EU": "45",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "UK": "11.5",
          "EU": "46.5",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "UK": "12",
          "EU": "47",
          "CM": "31"
        },
        {
          "US M": "13.5",
          "UK": "12.5",
          "EU": "47.5",
          "CM": "31.5"
        },
        {
          "US M": "14",
          "UK": "13",
          "EU": "48",
          "CM": "32"
        },
        {
          "US M": "14.5",
          "UK": "13.5",
          "EU": "48.5",
          "CM": "32.5"
        }
      ]
    },
    "ugg": {
      "label": "UGG Size Guide",
      "systems": [
        "US M",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "5",
          "EU": "36",
          "CM": "22"
        },
        {
          "US M": "6",
          "EU": "37",
          "CM": "23"
        },
        {
          "US M": "7",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "8",
          "EU": "39",
          "CM": "25"
        },
        {
          "US M": "9",
          "EU": "40",
          "CM": "26"
        },
        {
          "US M": "10",
          "EU": "41",
          "CM": "27"
        },
        {
          "US M": "11",
          "EU": "42",
          "CM": "28"
        }
      ]
    },
    "kailas": {
      "label": "KAILAS Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "displayLabels": {
        "US M": "US",
        "UK": "UK",
        "EU": "EU",
        "CM": "CM"
      },
      "rows": [
        {
          "US M": "4",
          "UK": "3.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "4.5",
          "UK": "4",
          "EU": "36.5",
          "CM": "23.3"
        },
        {
          "US M": "5",
          "UK": "4.5",
          "EU": "37",
          "CM": "23.7"
        },
        {
          "US M": "5.5",
          "UK": "5",
          "EU": "37.5",
          "CM": "24"
        },
        {
          "US M": "6",
          "UK": "5.5",
          "EU": "38",
          "CM": "24.4"
        },
        {
          "US M": "6.5",
          "UK": "6",
          "EU": "39",
          "CM": "25"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "40",
          "CM": "25.2"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41.5",
          "CM": "25.8"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "42",
          "CM": "25.8"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "42.5",
          "CM": "26.2"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "43",
          "CM": "26.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "44",
          "CM": "26.8"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "27.5"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "45",
          "CM": "28.2"
        },
        {
          "US M": "11.5",
          "UK": "10.5",
          "EU": "46",
          "CM": "28.8"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46.5",
          "CM": "29.2"
        },
        {
          "US M": "12.5",
          "UK": "11.5",
          "EU": "47",
          "CM": "29.5"
        }
      ]
    },
    "jordan": {
      "label": "Jordan Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3",
          "UK": "2.5",
          "EU": "35",
          "CM": "22"
        },
        {
          "US M": "3.5",
          "UK": "3",
          "EU": "35.5",
          "CM": "22.5"
        },
        {
          "US M": "4",
          "UK": "3.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "4.5",
          "UK": "4",
          "EU": "36.5",
          "CM": "23.5"
        },
        {
          "US M": "5",
          "UK": "4.5",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US M": "5.5",
          "UK": "5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6",
          "UK": "5.5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "UK": "10.5",
          "EU": "45.5",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "UK": "11.5",
          "EU": "47",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "UK": "12",
          "EU": "47.5",
          "CM": "31"
        },
        {
          "US M": "13.5",
          "UK": "12.5",
          "EU": "48",
          "CM": "31.5"
        },
        {
          "US M": "14",
          "UK": "13",
          "EU": "48.5",
          "CM": "32"
        },
        {
          "US M": "14.5",
          "UK": "13.5",
          "EU": "49",
          "CM": "32.5"
        },
        {
          "US M": "15",
          "UK": "14",
          "EU": "49.5",
          "CM": "33"
        },
        {
          "US M": "15.5",
          "UK": "14.5",
          "EU": "50",
          "CM": "33.5"
        },
        {
          "US M": "16",
          "UK": "15",
          "EU": "50.5",
          "CM": "34"
        },
        {
          "US M": "16.5",
          "UK": "15.5",
          "EU": "51",
          "CM": "34.5"
        },
        {
          "US M": "17",
          "UK": "16",
          "EU": "51.5",
          "CM": "35"
        },
        {
          "US M": "17.5",
          "UK": "16.5",
          "EU": "52",
          "CM": "35.5"
        },
        {
          "US M": "18",
          "UK": "17",
          "EU": "52.5",
          "CM": "36"
        }
      ]
    },
    "lining-clothing-pants": {
      "label": "Li-Ning Clothing & Pants Size Guide",
      "systems": ["Size"],
      "rows": [
        {"Size":"S"}, {"Size":"M"}, {"Size":"L"}, {"Size":"XL"}, {"Size":"2XL"}, {"Size":"3XL"}, {"Size":"4XL"}
      ],
      "tables": [
        {
          "label": "Li-Ning Clothing",
          "systems": ["Size", "Shoulder (in/cm)", "Chest (in/cm)", "Garment length (in/cm)", "Sleeve length (in/cm)"],
          "rows": [
            {"Size":"S","Shoulder (in/cm)":"25.2 / 128","Chest (in/cm)":"50.4 / 128","Garment length (in/cm)":"25.9 / 66","Sleeve length (in/cm)":"20 / 50.8"},
            {"Size":"M","Shoulder (in/cm)":"25.9 / 132","Chest (in/cm)":"51.9 / 132","Garment length (in/cm)":"26.7 / 68","Sleeve length (in/cm)":"20.4 / 51.9"},
            {"Size":"L","Shoulder (in/cm)":"26.7 / 136","Chest (in/cm)":"53.5 / 136","Garment length (in/cm)":"27.5 / 70","Sleeve length (in/cm)":"20.8 / 53"},
            {"Size":"XL","Shoulder (in/cm)":"27.5 / 140","Chest (in/cm)":"55.1 / 140","Garment length (in/cm)":"28.3 / 72","Sleeve length (in/cm)":"21.2 / 54.1"},
            {"Size":"2XL","Shoulder (in/cm)":"28.3 / 144","Chest (in/cm)":"56.6 / 144","Garment length (in/cm)":"29.1 / 74","Sleeve length (in/cm)":"21.7 / 55.2"},
            {"Size":"3XL","Shoulder (in/cm)":"29.1 / 148","Chest (in/cm)":"58.2 / 148","Garment length (in/cm)":"29.9 / 76","Sleeve length (in/cm)":"22.1 / 56.3"}
          ]
        },
        {
          "label": "Li-Ning Pants — Recommended size by height and weight",
          "systems": ["Height (cm/in)", "55–59 kg", "60–64 kg", "65–69 kg", "70–74 kg", "75–79 kg", "80–84 kg", "85–89 kg", "90–94 kg"],
          "rows": [
            {"Height (cm/in)":"160–165 / 62.9–64.9","55–59 kg":"S","60–64 kg":"S","65–69 kg":"S","70–74 kg":"M","75–79 kg":"M","80–84 kg":"L","85–89 kg":"—","90–94 kg":"—"},
            {"Height (cm/in)":"166–170 / 65.3–66.9","55–59 kg":"S","60–64 kg":"M","65–69 kg":"M","70–74 kg":"L","75–79 kg":"L","80–84 kg":"L","85–89 kg":"—","90–94 kg":"—"},
            {"Height (cm/in)":"171–175 / 67.3–68.8","55–59 kg":"M","60–64 kg":"M","65–69 kg":"L","70–74 kg":"L","75–79 kg":"L","80–84 kg":"L","85–89 kg":"XL","90–94 kg":"—"},
            {"Height (cm/in)":"176–180 / 69.2–70.8","55–59 kg":"M","60–64 kg":"L","65–69 kg":"L","70–74 kg":"XL","75–79 kg":"XL","80–84 kg":"XL","85–89 kg":"2XL","90–94 kg":"3XL"},
            {"Height (cm/in)":"181–185 / 71.2–72.8","55–59 kg":"—","60–64 kg":"L","65–69 kg":"XL","70–74 kg":"XL","75–79 kg":"XL","80–84 kg":"2XL","85–89 kg":"2XL","90–94 kg":"3XL"},
            {"Height (cm/in)":"186–190 / 73.2–74.8","55–59 kg":"—","60–64 kg":"—","65–69 kg":"XL","70–74 kg":"XL","75–79 kg":"2XL","80–84 kg":"2XL","85–89 kg":"3XL","90–94 kg":"4XL"},
            {"Height (cm/in)":"191–195 / 75.1–76.7","55–59 kg":"—","60–64 kg":"—","65–69 kg":"XL","70–74 kg":"2XL","75–79 kg":"2XL","80–84 kg":"3XL","85–89 kg":"4XL","90–94 kg":"4XL"}
          ]
        }
      ]
    },
    "rigorer-clothing": {
      "label": "Rigorer Clothing Size Guide",
      "systems": ["Size", "Shoulder (in/cm)", "Chest (in/cm)", "Waist (in/cm)", "Recommended height (in/cm)"],
      "rows": [
        {"Size":"XS","Shoulder (in/cm)":"21.06 / 53.5","Chest (in/cm)":"45.6 / 116","Waist (in/cm)":"44.8 / 114","Recommended height (in/cm)":">5'3\" / >160"},
        {"Size":"S","Shoulder (in/cm)":"21.8 / 55.5","Chest (in/cm)":"47.2 / 120","Waist (in/cm)":"46.4 / 118","Recommended height (in/cm)":"5'5\" / 160"},
        {"Size":"M","Shoulder (in/cm)":"22.6 / 57.5","Chest (in/cm)":"48.8 / 124","Waist (in/cm)":"48.0 / 122","Recommended height (in/cm)":"5'7\" / 170"},
        {"Size":"L","Shoulder (in/cm)":"23.4 / 59.5","Chest (in/cm)":"50.3 / 128","Waist (in/cm)":"49.6 / 126","Recommended height (in/cm)":"5'9\" / 175"},
        {"Size":"XL","Shoulder (in/cm)":"24.2 / 61.5","Chest (in/cm)":"51.9 / 132","Waist (in/cm)":"51.1 / 130","Recommended height (in/cm)":"5'11\" / 180"},
        {"Size":"2XL","Shoulder (in/cm)":"25 / 63.5","Chest (in/cm)":"53.5 / 136","Waist (in/cm)":"52.7 / 134","Recommended height (in/cm)":"5'11\" / 180"},
        {"Size":"3XL","Shoulder (in/cm)":"25.7 / 65.5","Chest (in/cm)":"55.1 / 140","Waist (in/cm)":"54.3 / 138","Recommended height (in/cm)":"6'0.8\" / 185"},
        {"Size":"4XL","Shoulder (in/cm)":"26.5 / 67.5","Chest (in/cm)":"56.6 / 144","Waist (in/cm)":"55.9 / 142","Recommended height (in/cm)":"6'2.8\" / 190"},
        {"Size":"5XL","Shoulder (in/cm)":"27.3 / 69.5","Chest (in/cm)":"58.2 / 148","Waist (in/cm)":"57.4 / 146","Recommended height (in/cm)":"6'4.8\" / 195"},
        {"Size":"6XL","Shoulder (in/cm)":"28.1 / 71.5","Chest (in/cm)":"59.8 / 152","Waist (in/cm)":"59.0 / 150","Recommended height (in/cm)":"6'6.7\" / 200"}
      ]
    },
    "anta-clothing": {
      "label": "ANTA Clothing Size Guide",
      "systems": ["Size", "Chest (in/cm)", "Recommended height (in/cm)"],
      "rows": [
        {"Size":"XS","Chest (in/cm)":"31.5 / 80","Recommended height (in/cm)":"5'3\" / 160"},
        {"Size":"S","Chest (in/cm)":"33 / 84","Recommended height (in/cm)":"5'5\" / 165"},
        {"Size":"M","Chest (in/cm)":"34.5 / 88","Recommended height (in/cm)":"5'7\" / 170"},
        {"Size":"L","Chest (in/cm)":"36 / 92","Recommended height (in/cm)":"5'9\" / 175"},
        {"Size":"XL","Chest (in/cm)":"38 / 96","Recommended height (in/cm)":"5'11\" / 180"},
        {"Size":"2XL","Chest (in/cm)":"39 / 100","Recommended height (in/cm)":"6'1\" / 185"},
        {"Size":"3XL","Chest (in/cm)":"41 / 104","Recommended height (in/cm)":"6'3\" / 190"},
        {"Size":"4XL","Chest (in/cm)":"42.5 / 108","Recommended height (in/cm)":"6'5\" / 195"}
      ]
    }
  },
  "templateMap": {
    "lining-size-chart-c-p": "lining-clothing-pants",
    "rigorer-clothing": "rigorer-clothing",
    "anta-clothing": "anta-clothing",
    "size-chart-lining-2": "lining",
    "size-chart-lining-kids": "lining-kids",
    "size-chart-anta": "anta",
    "anta-women": "anta",
    "size-chart-anta-kids": "anta-kids",
    "product-size-chart-peak": "peak",
    "peak-women": "peak",
    "size-chart-x-tep": "xtep",
    "bmai": "bmai",
    "qiaodan-2": "qiaodan",
    "qiaodan-women": "qiaodan",
    "under-amour": "under-armour",
    "erke": "erke",
    "tansher": "tansher",
    "rigorer-2": "rigorer-1",
    "rigorer-ar2": "rigorer-2",
    "rigorer-girl": "rigorer-1",
    "rigorer-kids": "rigorer-kids",
    "rigorer-slides": "rigorer-slides",
    "size-chart-361-361": "361-1",
    "size-chart-361-2": "361-2",
    "size-chart-361-dvd": "361-2",
    "size-chart-361-slides": "361-slides",
    "eqlz-2": "eqlz",
    "eqlz-slides": "eqlz-slides",
    "spo-size-chart": "spo",
    "adidas-yeezy": "adidas-yeezy",
    "size-chart-adidas": "adidas",
    "size-chart-asics": "asics",
    "size-chart-converse": "converse",
    "size-chart-mizuno": "mizuno",
    "size-chart-new-balance": "new-balance",
    "size-chart-puma": "puma",
    "size-chart-reebok": "reebok",
    "size-chart-ugg": "ugg",
    "size-chart-volanti": "volanti",
    "volanti-size-chart-2": "volanti",
    "adidasxenoburst": "adidas",
    "size-chart-kailas": "kailas",
    "kailas": "kailas"
  },
  "vendorMap": {
    "361": "361-1",
    "serious player only": "spo",
    "seriousplayeronly": "spo",
    "adidas yeezy": "adidas-yeezy",
    "yeezy": "adidas-yeezy",
    "jordan": "jordan",
    "air jordan": "jordan",
    "adidas": "adidas",
    "asics": "asics",
    "converse": "converse",
    "mizuno": "mizuno",
    "new balance": "new-balance",
    "newbalance": "new-balance",
    "puma": "puma",
    "reebok": "reebok",
    "ugg": "ugg",
    "volanti": "volanti",
    "li-ning": "lining",
    "lining": "lining",
    "anta": "anta",
    "peak": "peak",
    "xtep": "xtep",
    "x-tep": "xtep",
    "bmai": "bmai",
    "qiaodan": "qiaodan",
    "qiao dan": "qiaodan",
    "under armour": "under-armour",
    "erke": "erke",
    "tansher": "tansher",
    "rigorer": "rigorer-1",
    "361°": "361-1",
    "eqlz": "eqlz",
    "spo": "spo",
    "dowin": "dowin",
    "kailas": "kailas",
    "凯乐石": "kailas"
  }
};
